import { ApprovalStatus, ShippingStatus } from "@constant/ThroughShipment";
import {
  externalOrderState,
  fetchRetailList,
  setExternalOrdersFilter,
  fetchStaffList,
} from "@redux/externalOrderSlice";

import React, { useEffect } from "react";
import { Button, Col, Form, Row, Select, Input, DatePicker } from "antd";
import locale from "antd/es/date-picker/locale/zh_TW";
import moment from "moment";
import { useSelector } from "react-redux";
import styled from "styled-components";

import { useAppDispatch } from "src/store";

const CustomRangePicker = styled(DatePicker.RangePicker)`
  width: 100%;
`;
const Wrapper = styled(Form)`
  padding: 24px 0px 0px 16px;
`;
const CustomButton = styled(Button)`
  margin-right: 10px;
`;

export default function ExternalOrderFilter() {
  const [form] = Form.useForm();
  const dispatch = useAppDispatch();
  const { retailList, externalOrdersFilter, staffListResult } = useSelector(externalOrderState);

  const onReset = () => {
    form.resetFields();
    dispatch(
      setExternalOrdersFilter({
        limit: externalOrdersFilter.limit,
        offset: 0,
      }),
    );
    dispatch(fetchRetailList({}));
  };

  const onSubmit = (values: any) => {
    const { createdAt, shippingAt, deliveryAt, ...restValues } = values;

    const params = {
      ...externalOrdersFilter,
      ...restValues,
      createdAtAfter: values.createdAt ? moment(values.createdAt[0]).format("YYYY-MM-DD") : undefined,
      createdAtBefore: values.createdAt ? moment(values.createdAt[1]).format("YYYY-MM-DD") : undefined,
      shippingAtAfter: values.shippingAt ? moment(values.shippingAt[0]).format("YYYY-MM-DD") : undefined,
      shippingAtBefore: values.shippingAt ? moment(values.shippingAt[1]).format("YYYY-MM-DD") : undefined,
      deliveryAtAfter: values.deliveryAt ? moment(values.deliveryAt[0]).format("YYYY-MM-DD") : undefined,
      deliveryAtBefore: values.deliveryAt ? moment(values.deliveryAt[1]).format("YYYY-MM-DD") : undefined,
      invoiced: values.invoiced === undefined ? undefined : !!values.invoiced,
      offset: 0,
    };

    dispatch(setExternalOrdersFilter(params));
  };

  useEffect(() => {
    dispatch(fetchRetailList({}));
    dispatch(fetchStaffList());
  }, [dispatch]);

  const retailerOptions = retailList.results.map((item) => {
    return { value: item.name, label: item.name, text: item.id };
  });

  return (
    <Wrapper colon={false} labelAlign="left" form={form} initialValues={{}} onFinish={onSubmit} labelCol={{ span: 6 }}>
      <Row gutter={[12, 4]}>
        <Col span={8}>
          <Form.Item label="訂單編號" name="orderNumber">
            <Input />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item label="合作通路" name="retailerName">
            <Select
              showSearch
              placeholder="請選擇"
              optionFilterProp="children"
              filterOption={(inputValue, option) =>
                option!.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
              }
              options={retailerOptions}
            />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item label="SKU(品號)" name="sku">
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[12, 4]}>
        <Col span={8}>
          <Form.Item label="訂單申請人" name="staff">
            <Select defaultValue="-100">
              <Select.Option value="-100" disabled>
                請選擇
              </Select.Option>
              {staffListResult.results.map((item) => (
                <Select.Option key={item.id} value={item.id}>
                  {item.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item label="訂單狀態" name="shippingStatus">
            <Select
              placeholder="請選擇"
              options={[
                { label: "訂單取消", value: ShippingStatus.CANCELLED_W_DEPLOYED },
                { label: "待拋單", value: ShippingStatus.WAITING_TO_DEPLOY },
                { label: "訂單處理中(已拋單)", value: ShippingStatus.DEPLOY_SUCCESS },
                { label: "缺貨", value: ShippingStatus.OUT_OF_STOCK },
                { label: "揀貨中", value: ShippingStatus.PROCESS },
                { label: "已出貨", value: ShippingStatus.SHIPPED },
                { label: "配送異常", value: ShippingStatus.SHIPPING_ABNORMAL },
                { label: "已配達", value: ShippingStatus.PICKUP },
              ]}
            />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item label="審核狀態" name="approvalStatus">
            <Select defaultValue="-100">
              <Select.Option value="-100" disabled>
                請選擇
              </Select.Option>
              <Select.Option value={ApprovalStatus.APPROVED}>審核完成</Select.Option>
              <Select.Option value={ApprovalStatus.INVALID}>作廢</Select.Option>
              <Select.Option value={ApprovalStatus.REJECTED}>審核未通過</Select.Option>
              <Select.Option value={ApprovalStatus.AUDIT}>審核中</Select.Option>
              <Select.Option value={ApprovalStatus.PENDING}>待審核</Select.Option>
            </Select>
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[12, 4]}>
        <Col span={8}>
          <Form.Item label="發票號碼" name="invoiceNumber">
            <Input />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item label="發票狀態" name="invoiced">
            <Select placeholder="請選擇">
              <Select.Option value={1}>已開立</Select.Option>
              <Select.Option value={0}>未開立</Select.Option>
            </Select>
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[12, 4]}>
        <Col span={8}>
          <Form.Item label="訂單建立時間" name="createdAt">
            <CustomRangePicker locale={locale} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item label="倉庫建立時間" name="shippingAt">
            <CustomRangePicker locale={locale} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item label="實際出貨時間" name="deliveryAt">
            <CustomRangePicker locale={locale} />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={30}>
        <Col span={24}>
          <Row justify="end">
            <CustomButton onClick={onReset}>清除篩選條件</CustomButton>
            <Button type="primary" htmlType="submit">
              套用
            </Button>
          </Row>
        </Col>
      </Row>
    </Wrapper>
  );
}
